<script src="../../../store/email/moduleEmailMutations.js">
</script>
<template>
  <div id="receive-mail-detail">
    <div class="pt-10 mb-4 mr-6">
      <div id="action-button-detail" class="flex flex-wrap items-end justify-end">
        <vs-button :disabled="!isManager || readOnlyMail" class="mr-3" color="success" icon="assignment" @click="onSave">更新</vs-button>
        <vs-button :disabled="readOnlyMail || receive_mail.type === undefined" color="#8EB4E3" icon="mail" class="mr-3" @click="onSendForward">転送</vs-button>
        <vs-button :disabled="readOnlyMail || receive_mail.type === undefined" class="mr-3" color="#8EB4E3" icon="mail" @click="onSend">返信メール作成</vs-button>
        <vs-button color="#d9d9d9" icon="cancel" @click="onBack">閉じる</vs-button>
      </div>
    </div>
    
    <vx-card class="mt-5" no-radius cardBorder noShadow title="設定" collapseAction >
        <vs-row class="mt-5 mb-5" vs-w="12"  vs-type="flex">
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="inquiry_id" class="vs-input--label">ID </label>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7">
                <label id="inquiry_id" class="vs-input--label font-sans font-medium">{{$route.params.inquiry_id}}</label>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="mt-5 mb-5 " vs-w="12"  vs-type="flex">
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="receive_datetime" class="vs-input--label">お問い合わせ日</label>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7">
                <flat-pickr :disabled="isFormInValid || !isManager" 
                  id="receive_datetime" 
                  :class="isFormInValid || !isManager?'disabled-input':''"
                  class="w-full flatpickr-style" 
                  v-model="receive_mail.receive_datetime"
                  :config="configDate_inquire">
                </flat-pickr>
              </vs-col>

            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="state_flg" class="vs-input--label">状態</label>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7">
                <v-select class="w-full" v-validate="'required'"  name="state_flg" 
                          id="state_flg"
                          v-model="state_flg"
                          :options="listSelectStateFlag"
                          :disabled="!isManager">
                  <span slot="no-options">すみません、マッチングオプションがありません。</span>
                </v-select>
              </vs-col>
              <span v-if="errors.has('state_flg')" style="color:red;">
                {{ errors.first("state_flg") }}
              </span>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="email_sender" class="vs-input--label">お問い合わせ者</label>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7">
                <vs-input class="w-full" :readonly="isFormInValid || !isManager"
                          :class="isFormInValid?'disabled-input':''"
                          id="email_sender"
                          name="email_sender"
                          :maxlength="512"
                          v-model="receive_mail.email_sender_full_table"
                          />
              </vs-col>
                <span v-if="errors.has('state_flg')" style="color:white;">
                {{ errors.first("state_flg") }}
                </span>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="mt-5 mb-5 " vs-w="12"  vs-type="flex">
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="response_limit" class="vs-input--label">回答期日</label>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7">
                <flat-pickr name="response_limit" 
                            id="response_limit" 
                            :class="{'response-limit-disabled': !isManager}"
                            class="w-full flatpickr-style" 
                            v-model="receive_mail.response_limit" 
                            :config="isManager ? configDate:configDate_inquire"
                            :disabled="!isManager"></flat-pickr>
              </vs-col>
                <span v-if="errors.has('type')" style="color:white;"  >
                {{ errors.first("type") }}
                </span>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="type" class="vs-input--label">種別</label>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7">
                <v-select class="w-full" v-validate="'required'" name="type"
                        id="type"
                        v-model="receive_mail.type"
                        :options="listTypeSelect"
                        :disabled="!isManager">
                  <span slot="no-options">すみません、マッチングオプションがありません。</span>    
                </v-select>
              </vs-col>
              <span v-if="errors.has('type')" style="color:red;">
                {{ errors.first("type") }}
              </span>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="mst_admin_id" class="vs-input--label">管理者</label>
              </vs-col>
              <vs-col vs-type="flex" vs-w="7">
                  <v-select class="w-full" name="mst_admin_id"
                            id="mst_admin_id"
                            v-model="receive_mail.mst_admin_id"
                            :options="listAdmin"
                            :disabled="!isManager">
                    <span slot="no-options">すみません、マッチングオプションがありません。</span>
                  </v-select>
              </vs-col>
                <span v-if="errors.has('type')" style="color:white;">
                {{ errors.first("type") }}
              </span>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="mt-5 mb-5 " vs-w="12"  vs-type="flex">
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="mst_user_id" class="vs-input--label">担当者</label>
              </vs-col>
              <vs-col vs-type="flex"  vs-w="7">
                <v-select class="w-full" name="mst_user_id"
                          id="mst_user_id"
                          v-model="mst_user_id"
                          :options="listUser"
                          v-validate="'required'"
                          :disabled="!isManager">
                  <span slot="no-options">すみません、マッチングオプションがありません。</span>
                </v-select>
              </vs-col>
                <span v-if="errors.has('mst_user_id')" style="color:red;">
                {{ errors.first("mst_user_id") }}
                </span>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="mst_user_id" class="vs-input--label">問い合わせ種別</label>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="7">
                <v-select class="w-full isabled-input"
                          id="inquiry_type"
                          name="inquiry_type"
                          v-model="receive_mail.inquiry_type"
                          :options="listInquiryTypeSelect"
                          disabled>
                  <span slot="no-options">すみません、マッチングオプションがありません。</span>
                </v-select>
              </vs-col>
                <span v-if="errors.has('mst_user_id')" style="color:white;">
                {{ errors.first("mst_user_id") }}
                </span>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label class="vs-input--label">顧客</label>
              </vs-col>
              <vs-col  vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label v-if="customerInfo" v-text="customerInfo.company_name ? customerInfo.company_name : customerInfo.customerName" @click="showCustomerInfoDialog = !showCustomerInfoDialog" class="vs-input--label lb-custom"></label>
              </vs-col>
              <vs-popup title="顧客情報" :active.sync="showCustomerInfoDialog">
                <div v-if="customerInfo" class="ml-4">
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">ID：</label>
                    <span v-text="customerInfo.id"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">会社名：</label>
                    <span v-text="customerInfo.company_name"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">お客様種別：</label>
                    <span v-text="customerInfo.customer_type_flg"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">名前：</label>
                    <span v-text="customerInfo.customerName"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">性別：</label>
                    <span v-text="customerInfo.gender"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">メールアドレス：</label>
                    <span v-text="customerInfo.email1 ? customerInfo.email1 : customerInfo.email2"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">ドメイン：</label>
                    <span v-text="customerInfo.mail_domain"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">電話番号：</label>
                    <span v-text="customerInfo.phone_number1 ? customerInfo.phone_number1 : customerInfo.phone_number2"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">業種：</label>
                    <span v-text="customerInfo.industry_name"></span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center">
                    <label class="vs-input--label">住所：</label>
                    <span v-text="customerInfo.address"></span>
                  </vs-col>
                </div>
                <div v-else class="ml-4 text-center">This email haven't link to customer, you can choose a customer yourseft in setting.</div>
              </vs-popup>

              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                <vs-button icon="edit" @click="changeCustomer" color="warning"></vs-button>
              </vs-col>
              <vs-popup title="顧客に紐づく変更" :active.sync="changeCusomerDialog" @focusout="closeUpdate" button-close-hidden>
                <vs-row class="mb-3 d-flex">
                  <vs-col vs-w="4">
                    <vs-input v-model="search_text" placeholder="会社名または氏名"></vs-input>
                  </vs-col>
                  <vs-col vs-w="3" class="ml-8 mx-0" style="position: relative;">
                    <vs-button @click="searchCustomerForLink()" color="primary" icon="search" style="position: absolute; bottom: 0; left: 10px;">検索</vs-button>
                  </vs-col>
                </vs-row>
                <vs-table v-model="customerChoose" v-if="customerList && customerList.length"
                          @selected="handleSelected" :noDataText="customerList.length < 1 ? 'データがありません' :''">
                  <template #thead>
                    <vs-th>
                      ID
                    </vs-th>
                    <vs-th>
                      名前
                    </vs-th>
                    <vs-th>
                      メール
                    </vs-th>
                    <vs-th>
                      企業名
                    </vs-th>
                    <vs-th>
                      ドメイン
                    </vs-th>
                  </template>

                  <template v-slot="tbody">
                    <vs-tr class="customerItem"  v-for="customer in customerList" :key="customer.id" :data="customer">
                      <vs-td>
                        {{customer.id}}
                      </vs-td>
                      <vs-td >
                        {{customer.last_name}}
                      </vs-td>
                      <vs-td >
                        {{customer.email1}}
                      </vs-td>
                      <vs-td >
                        {{customer.company_name}}
                      </vs-td>
                      <vs-td >
                        {{customer.mail_domain}}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <vs-row class="mb-4" vs-justify="center" vs-align="center">
                  <div class="flex flex-col items-center">
                    <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
                  </div>
                </vs-row>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
                  <vs-button @click="customerDomainUpdate" icon="assignment" :disabled="!canUpdate" color="success" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
                  <vs-button @click="closeUpdate" icon="cancel" color="lightgrey" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
                </vs-col>
              </vs-popup>
                <span v-if="errors.has('mst_user_id')" style="color:white;">
                {{ errors.first("mst_user_id") }}
              </span>

            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="mt-5" vs-w="12" vs-type="flex">
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="mst_user_id" class="vs-input--label">優先度</label>
              </vs-col>
              <vs-col vs-type="flex"  vs-w="7">
                <v-select class="w-full" name="priority"
                          id="priority"
                          v-model="priority"
                          :options="listPriority"
                          @open="openvSelectPriority"
                          @input="selectionChangedPriority">
                  <span slot="no-options">すみません、マッチングオプションがありません。</span>
                </v-select>
              </vs-col>
            </vs-row>
          </vs-col>
          <!-- PAC_21-140 -->
          <vs-col vs-type="flex" vs-w="4">
            <vs-row vs-justify="space-around" vs-w="12">
              <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
                <label for="mst_user_id" class="vs-input--label">保存先フォルダ</label>
              </vs-col>
              <vs-col vs-type="flex"  vs-w="7">
                <v-select class="w-full" name="folder"
                          id="folder"
                          v-model="update_folder"
                          placeholder="..."
                          :options="listFolderUpdate"
                          :disabled="isSpamView">
                  <span slot="no-options">すみません、マッチングオプションがありません。</span>
                </v-select>
              </vs-col>
            </vs-row>
          </vs-col>
          <!--END PAC_21-140 -->
        </vs-row>
        <img id="gif-low-priority" style="display:none" src="@/assets/images/other-icons/low-priority.gif"/>
        <img id="gif-medium-priority" style="display:none" src="@/assets/images/other-icons/medium-priority.gif"/>
        <img id="gif-high-priority" style="display:none" src="@/assets/images/other-icons/high-priority.gif"/>
    </vx-card>

    <vs-row class="mt-12">
      <vs-col>
        <vx-input-group class ="square" type="file">
          <template slot="prepend">
            <div class="prepend-text label-style">
              <span>From</span>
            </div>
          </template>

          <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="receive_mail.email_sender_full" placeholder="email_sender_full" />
        </vx-input-group>
      </vs-col>
      <vs-col>
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text label-style">
              <span>To</span>
            </div>
          </template>

          <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="receive_mail.to" placeholder="" />
        </vx-input-group> 
      </vs-col>
      <vs-col>
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text label-style">
              <span>CC</span>
            </div>
          </template>

          <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="receive_mail.cc" />
        </vx-input-group> 
      </vs-col>
      <vs-col class="mt-5" v-if="receive_mail.error_detail">
        <div class="prepend-text label-style w-full" style="padding:10px">
          <span class="mr-5"><img src="@/assets/images/other-icons/error.png" style="position: relative;top: 3px;"/></span>
          <span>エラー内容</span>
        </div>
        <vx-card
          class="card-body-mail"
          no-radius
          cardBorder
          :class="isFormInValid ? 'disabled-input' : ''"
        >
          <div
            class="w-full"
            v-html="receive_mail.error_detail"
            style="height: 150px; overflow-y: scroll"
          ></div>
        </vx-card>
      </vs-col>
      <vs-col class="mt-5" style="border: solid 1px #E2E2E2">
        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text label-style" style="width: 120px;">
              <span>添付ファイル</span>
            </div>
          </template>
          <vs-row>
            <vs-col style="width: max-content; padding: 3px 5px;" :key="index" v-for="(value, index) in receive_mail.attachmentFileName">
              <div @click="downloadAttachment(value.path)">
                <vs-chip style="cursor: pointer;" class="mt-1" color="dark" transparent>{{ value.file_name | convertFileNameReceive }}</vs-chip>
              </div>
            </vs-col>
          </vs-row>
        </vx-input-group> 
      </vs-col>  
    </vs-row>

    <vs-row class="mt-6">
      <vx-card class="card-body-mail" no-radius cardBorder noShadow title="件名" :class="isFormInValid?'disabled-input':''">
        <div class="w-full" v-html="receive_mail.subject" style="padding: 9.8px"></div>
      </vx-card>    
      
      <vx-card class="card-body-mail" no-radius cardBorder noShadow title="お問い合わせ本文" :class="isFormInValid?'disabled-input':''" >
        <quill-editor disabled v-if="receive_mail.body_type == 0" style="height: 560px;" v-model="receive_mail.body" :options="editorOption"/>
        <!-- <div class="pl-2 pt-2" v-if="receive_mail.body_type == 0" v-html="receive_mail.body" style="height: 560px; overflow-y: scroll;"></div> -->
        <vs-textarea v-else :readonly="isFormInValid"  v-model="receive_mail.body" placeholder="..." height="560px"/>
      </vx-card>
    </vs-row>

    <vx-card class="mt-12" no-radius cardBorder noShadow title="サポート回答" v-if="listThread.length" >
      <vs-table @selected="viewThreadMail" :data="listThread" stripe noDataText hoverFlat style="border: solid 1px #000000;  border-bottom: 0;" >
        <template slot-scope="{data}">
            <vs-tr class="border-tr" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="border-td">
                    返信{{indextr+1}}{{tr.name_view_send ? ', ' + tr.name_view_send :''}}
                </vs-td>
                <vs-td>
                    {{tr.subject}}
                </vs-td>
            </vs-tr>
        </template>
      </vs-table>  
    </vx-card>
      
  </div>
</template>

<script>

import flatPickr from 'vue-flatpickr-component';
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css';
import {Japanese} from 'flatpickr/dist/l10n/ja.js';
import {mapMutations, mapActions, mapGetters} from "vuex";
import { Validator } from 'vee-validate';
import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
import { notifyEmptyReceive } from "@/utils/helpler-utils";
import customer from "@/store/admin/customer";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from "vue-quill-editor";

const dict = {
    custom: {  
      state_flg: {
        required: '* 必須項目です'
      },             
      type: {
        required: '* 必須項目です'
      },
        mst_user_id: {
            required: '* 必須項目です'
        }
    },
  };
Validator.localize('ja', dict);


export default {
  components: {
    flatPickr,
    vSelect,
    quillEditor
  },
  
  data() { 
    return {
      isFormInValid: true,
      receive_mail: [],
      listUser:[
        {
          label: '...',
          value: ''
        }
      ],
      update_folder: null, // PAC_21-140
      isSpamView: false, //true: show spam mail
      mst_user_id: '',
      state_flg: '',
      priority: '',
      listAdmin:[],
      mailNotUser: false,
      isManager:   true,
      configDate_inquire: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: '',
        dateFormat: 'Y-m-d H:i:S',
        enableTime: true,
        enableSeconds: true,
        // minDate: '',
      },
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: '',
        minDate: '',
      },
      listThread: [],
      listInquiryTypeSelect: [
        {value: 0, label: 'メール'},
        {value: 1, label: '電話'},
        {value: 2, label: '営業'},
        {value: 3, label: 'その他'}
      ],
      listSelectStateFlag : [
        {value: 0,label: '未対応'},
        {value: 1,label: '対応中'},
        {value: 2,label: '返信済（回答待ち）'},
        {value: 3,label: '返信済'},
        {value: 4,label: '完了'},

      ],
      listTypeSelect: [
        ''
      ],
      listPriority: [
        {value: 0,label: '...'},
        {value: 1,label: '低'},
        {value: 2,label: '中'},
        {value: 3,label: '高'},
      ],
      readOnlyMail : false, //true: hide button 更新 , 返信メール作成

      //todo for customer info
      showCustomerInfoDialog: false,
      changeCusomerDialog: false,
      customerInfo: null,
      customerList: [],
      customerChoose: null,
      canUpdate: false,


      search_text: null,
      currentPage: 1,
      totalPage: 1,
      editorOption: {
        modules: {
          toolbar: false
        },
        placeholder: ''
      },
    }
  },
  
  methods: {
    ...mapActions({
      getMailReceive: 'receiveMail/getReceiveMailDetail',
      getListThread: 'receiveMail/getListThread',
      downloadFile: "receiveMail/downloadAttachment",
      updateMailReceivedDetail: 'receiveMail/updateMailReceivedDetail',
      getListMailBox: 'receiveMail/getListMailBox',
      getListKinds: 'kinds/getListKinds',

      //customer domain
      showCustomer: 'customerDomain/showCustomer',
      updateCustomerDomain: 'customerDomain/updateCustomerDomain',
      searchCustomerLink: 'customerDomain/searchCustomerLink',
    }),
    ...mapMutations({
      setThreadMailDetail: 'receiveMail/SET_THREAD_MAIL_DETAIL'
    }),

    //todo mail customer info
      async getCustomerByEmail(){
        await this.showCustomer(this.receive_mail.email_sender)
            .then(response =>{
              this.customerInfo = response
                if (this.customerInfo) {
                    if (this.customerInfo.last_name && this.customerInfo.first_name) this.customerInfo.customerName = this.customerInfo.last_name + ' ' + this.customerInfo.first_name;
                    if (this.customerInfo.gender) {
                        if(this.customerInfo.gender == 0) this.customerInfo.gender = "男"
                        else if(this.customerInfo.gender == 1) this.customerInfo.gender = '女'
                        else this.customerInfo.gender = 'その他';
                    }
                    if (this.customerInfo.customer_type_flg) {
                        switch (this.customerInfo.customer_type_flg){
                            case 0: this.customerInfo.customer_type_flg = '個人消費者'
                                break
                            case 1: this.customerInfo.customer_type_flg = '法人消費者'
                                break
                            case 2: this.customerInfo.customer_type_flg = '販売店'
                                break
                            case 3: this.customerInfo.customer_type_flg = '支店'
                                break
                            default: this.customerInfo.customer_type_flg = 'その他'
                        }
                    }
                }

            });
      },

    handleSelected(tr){
    },
    closeUpdate(){
      this.customerChoose = null
      this.canUpdate = false;
      this.search_text = null;
      this.changeCusomerDialog = false;
    },



    async customerDomainUpdate(){
      this.customerChoose.email = this.receive_mail.email_sender
      await this.updateCustomerDomain({...this.customerChoose});
      this.closeUpdate();
      this.getCustomerByEmail();
    },

    async changeCustomer(){
      this.changeCusomerDialog = true;
      await this.searchCustomerForLink();
    },

    async searchCustomerForLink(page = 1){
      this.customerChoose = null;
      let customer_domain = '@' + this.receive_mail.email_sender.split('@')[1];
      let data = {
        page: page,
        search_text: this.search_text,
        domain: customer_domain,
      };
      await this.searchCustomerLink({params: data}).then(res =>{
        this.customerList = res.data;
        if(this.customerInfo){
          this.customerList = this.customerList.filter(customer=>customer.id !== this.customerInfo.id);
        }
        this.currentPage = res.current_page;
        this.totalPage = res.last_page;
      })
    },
    //end customer info

    async downloadAttachment(file) {
      let data = {
        "id" : this.receive_mail.id,
        "fileName" : file,
      }
      let result = await this.downloadFile(data);
      if (result) {
          const content = result.file_data;
          let fileName = result.file_name;
          let typeDownload = result.file_type;
          // Decode base64 using atob method
          let data = window.atob(content);
          let bytes = new Array(data.length);
          for (let i = 0; i < data.length; i++) {
              bytes[i] = data.charCodeAt(i);
          }
          data = new Uint8Array(bytes);
          let anchor = document.createElement('a');
          if (anchor.download !== undefined) {
            let blob = new Blob([data], {type: typeDownload});
            var objectURL = window.URL.createObjectURL(blob);

            anchor.href = objectURL;
            anchor.download = fileName;
          }
          if (navigator.msSaveBlob) { // IE 10+
            anchor.addEventListener("click", function (event) {
              let blob = new Blob([data], {
                "type": 'text'
              });
              navigator.msSaveBlob(blob, fileName);
            }, false);
          }

          anchor.click();

          URL.revokeObjectURL(objectURL);
      }
    },
    onSave: async function() {
      const dataMailReceive = await this.fetchMailReceiveSafely();
      if (!dataMailReceive) return;
      if((this.state_flg.value == 0) || (this.mst_user_id.value == 0)){
        if(!this.mailNotUser && this.listThread.length > 0){ 
          this.$vs.notify({
            position: 'bottom-right',
            text: 'サポート回答があるので、お問い合わせ詳細の更新に失敗しました。',
            color: 'danger'
          })
        }else if((this.state_flg.value == 0)){
          this.$validator.validate().then(async valid => {
            if (valid) {
              let data = {
                id: this.receive_mail.id,
                state_flg: 0,
                response_limit: this.receive_mail.response_limit ? this.receive_mail.response_limit : '',
                type: this.receive_mail.type.value,
                mst_admin_id: this.receive_mail.mst_admin_id ? this.receive_mail.mst_admin_id.value : '',
                mst_user_id: this.mst_user_id ? this.mst_user_id.value : '',
                inquiry_type: this.receive_mail.inquiry_type ? this.receive_mail.inquiry_type.value:0,
                priority: this.priority ? this.priority.value : 0,
                folder : this.update_folder.value
              };
                
              await this.updateMailReceivedDetail(data)
              this.getListMailBox()
              this.mailNotUser = true
              localStorage.setItem('refreshPage' , true);
            }
          })
        }
        else{
          this.$vs.notify({
            position: 'bottom-right',
            text: '担当者が入力していないため、お問い合わせ詳細の更新に失敗しました。',
            color: 'danger'
          })
        }
      }
      else{  
        this.$validator.validate().then(async valid => {
          if (valid) {
            let data = {
              id: this.receive_mail.id,
              state_flg: this.state_flg.value,
              response_limit: this.receive_mail.response_limit ? this.receive_mail.response_limit : '',
              type: this.receive_mail.type.value,
              mst_admin_id: this.receive_mail.mst_admin_id ? this.receive_mail.mst_admin_id.value : '',
              mst_user_id: this.mst_user_id ? this.mst_user_id.value : '',
              inquiry_type: this.receive_mail.inquiry_type ? this.receive_mail.inquiry_type.value:0,
              priority: this.priority ? this.priority.value : 0,
              folder : this.update_folder.value
            };
            await this.updateMailReceivedDetail(data).then(response => {
               //update sucess => mail setup
              this.mailNotUser = false
              // check user is Manager ?
              // if(this.$store.state.AppActiveUser.id == this.mst_user_id.value || this.mst_user_id.value == null) this.isManager = true;
              // else this.isManager = false
              this.getListMailBox()
              localStorage.setItem('refreshPage' , true);
            })
          }
        });
      }
    },
    onBack: async function() {
      let url = new URL(window.location.href);
      let close = url.searchParams.get("back");
      if (close){
        window.close();
      }
      else{
        if (this.selectedMailFolder) {
          this.$router.push({path: this.selectedMailFolder});
        } else {
        this.$router.push({path:`/box/${this.$route.params.email}`});
        }
      }
    },
    onSend: async function() {
      const dataMailReceive = await this.fetchMailReceiveSafely();
      if (!dataMailReceive) return;
      let url = new URL(window.location.href);
      let close = url.searchParams.get("back");
          let messageError = null;
          if (this.receive_mail.type == null) messageError = 'このメールは種別の設定がありません。';
          if (this.mst_user_id == undefined || this.mst_user_id.value == null || this.mst_user_id.value == '' || this.state_flg == null) messageError = 'このメールは担当者と状態の設定がありません。';
          if (messageError == null ) {
            if(this.mst_user_id.value != 0){
              await this.onSave()
              if(this.mailNotUser){
                localStorage.setItem('refreshPage' , true);
                  this.setInfoMailDetail(close)
              }
              else {
                  this.setInfoMailDetail(close)
              }
            } else{
                      if(!this.mailNotUser) {
                          this.setInfoMailDetail(close)
                    } else {
                          if (messageError !== null ) {
                              this.$vs.notify({
                                  position: 'bottom-right',
                                  text: '123。',
                                  color: 'danger'
                              })
                          } else {
                             this.setInfoMailDetail(close)
                          }
                      }
                    }
                } else {
                    this.$vs.notify({
                        position: 'bottom-right',
                        text: messageError,
                        color: 'danger'
                    })

                }
      },
      onSendForward: async function() {
          const dataMailReceive = await this.fetchMailReceiveSafely();
          if (!dataMailReceive) return;
          let url = new URL(window.location.href);
          let close = url.searchParams.get("back");
          let messageError = null;
          if (this.receive_mail.type == null) messageError = 'このメールは種別の設定がありません。';
          if (this.mst_user_id == undefined || this.mst_user_id.value == null || this.mst_user_id.value == '' || this.state_flg == null) messageError = 'このメールは担当者と状態の設定がありません。';
          if (messageError == null ) {
            if(this.mst_user_id.value != 0){
              await this.onSave()
              if(this.mailNotUser){
                localStorage.setItem('refreshPage' , true);
                  this.setInfoMailForwardDetail(close)
              }
              else {
                  this.setInfoMailForwardDetail(close)
              }
            } else{
                      if(!this.mailNotUser) {
                          this.setInfoMailForwardDetail(close)
                    } else {
                          if (messageError !== null ) {
                              this.$vs.notify({
                                  position: 'bottom-right',
                                  text: '',
                                  color: 'danger'
                              })
                          } else {
                             this.setInfoMailForwardDetail(close)
                          }
                      }
                    }
                } else {
                    this.$vs.notify({
                        position: 'bottom-right',
                        text: messageError,
                        color: 'danger'
                    })

                }
      },
      setInfoMailDetail(close) {
          if (close) {
            let routePath = `/box/${this.$route.params.email}/${this.$route.params.inquiry_id}/reply`;
            if (this.$route.query.mode === 'shachihatadesk') {
              routePath += '?opener=true&mode=shachihatadeskopener';
              if (this.$route.query.urlorigin) {
                routePath += `&urlorigin=${this.$route.query.urlorigin}`;
              }
            }
            this.$router.push({path: routePath});
          } else {
              this.$router.push({path:`/box/${this.$route.params.email}/${this.$route.params.inquiry_id}/reply?back=true`});
          }
          let mailDetail = {
              type: (this.receive_mail && this.receive_mail.type) ? this.receive_mail.type : null,
              state_flg: this.state_flg ? this.state_flg : null,
              mst_user: this.mst_user_id ? this.mst_user_id : null,
              from: this.receive_mail.from ? this.receive_mail.from : null,
          }
          this.$store.commit('receiveMail/SET_MAIL_DETAIL', mailDetail)

      },
      setInfoMailForwardDetail(close) {
          if (close) {
            let routeForwardPath = `/box/${this.$route.params.email}/${this.$route.params.inquiry_id}/forward-mail?send-forward=true`;
            if (this.$route.query.mode === 'shachihatadesk') {
              routeForwardPath += '&opener=true&mode=shachihatadeskopener';
              if (this.$route.query.urlorigin) {
                routeForwardPath += `&urlorigin=${this.$route.query.urlorigin}`;
              }
            }
            this.$router.push({path: routeForwardPath});
          } else {
              this.$router.push({path:`/box/${this.$route.params.email}/${this.$route.params.inquiry_id}/forward-mail?back=true`});
          }
          let mailDetail = {
              type: (this.receive_mail && this.receive_mail.type) ? this.receive_mail.type : null,
              state_flg: this.state_flg ? this.state_flg : null,
              mst_user: this.mst_user_id ? this.mst_user_id : null,
              from: this.receive_mail.from ? this.receive_mail.from : null,
          }
          this.$store.commit('receiveMail/SET_MAIL_DETAIL', mailDetail)
      },
    async viewThreadMail(tr){
      const dataMailReceive = await this.fetchMailReceiveSafely();
      if (!dataMailReceive) return;
      let index = this.listThread.findIndex(mail => mail.id == tr.id )
      this.setThreadMailDetail(Object.assign(tr, {index: index + 1}))
      this.$router.push({path:`/box/${this.$route.params.email}/${this.$route.params.inquiry_id}/reply/${tr.id}?view-thread-mail=true&back=true`});
    },
    async getListKindsSelect() {
      let response = await this.getListKinds()
      if (response) {

        this.listTypeSelect = [
          ''
        ]
        response.map(element => {
          let result = { }
          result.value = element.type_id
          result.label = element.kinds_name
          this.listTypeSelect.push(result)
        })
      } else {
        this.listTypeSelect = [
          ''
        ]
      }
    },
    openvSelectPriority(){
      setTimeout(()=>{
        const lowPriority = document.getElementById("gif-low-priority").getAttribute("src");
        const mediumPriority = document.getElementById("gif-medium-priority").getAttribute("src");
        const highPriority = document.getElementById("gif-high-priority").getAttribute("src");
        const colectionGif = [' ' , lowPriority, mediumPriority, highPriority]
        const priority = document.querySelectorAll('#priority>ul>li');
        if (priority && priority.length > 0) {
          priority.forEach((element, index)=>{
            let gif = document.createElement('img');
            gif.src = colectionGif[index]
            gif.style = "display:inline"
            element.prepend(gif)
          })
        }
      },0)
    },
    selectionChangedPriority() {
      setTimeout(()=>{
        const lowPriority = document.getElementById("gif-low-priority").getAttribute("src");
        const mediumPriority = document.getElementById("gif-medium-priority").getAttribute("src");
        const highPriority = document.getElementById("gif-high-priority").getAttribute("src");
        const colectionGif = [lowPriority, mediumPriority, highPriority]
        const contentApplyGif = ['低', '中', '高']
        const priority = document.querySelectorAll('#priority>div>div>span');
        if (priority && priority.length > 0) {
          contentApplyGif.forEach((element, index) => {
            if (priority[0].textContent.includes(element)) {
              let gif = document.createElement('img');
              gif.src = colectionGif[index]
              gif.style = "display:inline"
              priority[0].prepend(gif)
            }
          })
        }
      })
    },
    async fetchMailReceiveSafely() {
      const data = {
          'email' : this.$route.params.email,
          'inquiry_id' : this.$route.params.inquiry_id
      }

      let result = await this.getMailReceive(data);

      if (!result) {
          this.$vs.notify({
              position: 'bottom-right',
              text: notifyEmptyReceive,
              color: 'danger'
          });
          localStorage.setItem('refreshPage', true);
          return false;
      }
      return result;
    }
  },
  computed: {
    ...mapGetters({
      selectedMailFolder: 'mailFolder/selectedMailFolder',
      listFolderReceiveMail: "mailRule/listFolderReceiveMail",
    }),
    listFolderUpdate(){
      let listFolderUpdate = [];
      if ( !this.listFolderReceiveMail || this.listFolderReceiveMail.length == 0){
        listFolderUpdate = [{ label : "...", value : null}]
      }
      else{
        listFolderUpdate = [];
        this.listFolderReceiveMail.forEach(folder =>{
          listFolderUpdate.push(Object.assign({
            label : folder.name, value : folder.id}));
        });
        listFolderUpdate.unshift({label : "受信", value : null});
      }
      return listFolderUpdate;
    }
  },

  async created () {
    /* start loading with many requests */
    this.$store.dispatch('updateLoads', true)

    const data = {
      'email' : this.$route.params.email,
      'inquiry_id' : this.$route.params.inquiry_id
    }

    let dataMailReceive = await this.getMailReceive(data);
    if (dataMailReceive) {
        this.listThread = await this.getListThread(data);
    } else {
        this.$vs.notify({
            position: 'bottom-right',
            text: notifyEmptyReceive,
            color: 'danger'
        });
        localStorage.setItem('refreshPage', true);
    }
    
    this.listUser = [
      {
        label: '...',
        value: ''
      }
    ]
    this.listTypeSelect = [
      ''
    ]
    if (dataMailReceive) {
      
      dataMailReceive.list_user.map(element => {
        let result = { }
        result.value = element.id
        result.label = element.full_name
        this.listUser.push(result)
      })

      this.listAdmin = dataMailReceive.list_admin.map(element => {
        let result = { }
        result.value = element.id
        result.label = element.full_name
        return result
      })

      await this.getListKindsSelect()
      this.receive_mail = dataMailReceive.receive_mail;
      //check email_sender_full
      if (!this.receive_mail.email_sender_full || this.receive_mail.email_sender_full == "") {
        this.receive_mail.email_sender_full = this.receive_mail.email_sender;
      }
      //check manager mail ?
      if(this.receive_mail.state_flg == 0 || this.receive_mail.mst_user_id == null) this.mailNotUser = true;
      else this.mailNotUser = false
      // // check user is Manager ?
      // if(this.$store.state.AppActiveUser.id == this.receive_mail.mst_user_id || this.mailNotUser) this.isManager = true;
      // else this.isManager = false

      this.state_flg = this.listSelectStateFlag.find(state => state.value == dataMailReceive.receive_mail.state_flg);
      this.receive_mail.type = this.listTypeSelect.find(type => type.value == dataMailReceive.receive_mail.type);
      if(this.receive_mail.type === undefined){
          this.receive_mail.type = this.listTypeSelect.find(type => type.value == 0) || this.listTypeSelect[1];
      }
      this.mst_user_id = this.listUser.find(user => user.value == dataMailReceive.receive_mail.mst_user_id) || this.listUser[0];
      this.update_folder =  this.listFolderUpdate.find(folder => folder.value == dataMailReceive.receive_mail.folder);
      this.isSpamView = dataMailReceive.receive_mail.type_mail === 1 ? true : false;

      this.receive_mail.mst_admin_id = this.listAdmin.find(admin => admin.value == dataMailReceive.receive_mail.mst_admin_id);
      this.receive_mail.inquiry_type = this.listInquiryTypeSelect.find(item => item.value == dataMailReceive.receive_mail.inquiry_type);
      this.readOnlyMail= dataMailReceive.read_only > 0
      this.priority = this.listPriority.find(priority => priority.value == dataMailReceive.receive_mail.priority)
      this.selectionChangedPriority();
      this.configDate.minDate = this.$moment().format('YYYY-MM-DD');
      this.getCustomerByEmail();
    }

    /* stop loads */
      localStorage.setItem('refreshPage', true);
      this.$store.dispatch('updateLoads', false)
  },
  watch: {
    customerChoose(){
      if(this.customerChoose != null){
        this.canUpdate = true
      } else this.canUpdate = false
    },
    async currentPage(){
      this.customerChoose = null;
      await this.searchCustomerForLink(this.currentPage);
    },
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
#action-button-detail {
  .vs-button--text {
    line-height: 20px !important;
  }
}

</style>
<style scoped>
.lb-custom{
  text-decoration: underline;
  cursor:pointer;
}
.lb-custom:hover{
  color: red;
}
.customerItem{
  cursor: pointer;
}
.customerItem:focus{
  background-color: #e4eaf5;
  color: #5897fb;
}

</style>
